import React from "react";
import { PageNewState, rootComponentEditDialogInitialState } from ".";

export const RootComponentEditDialogContext = React.createContext({
  pageState: rootComponentEditDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
